const global = window
export const requestIdleCallback = global.requestIdleCallback || global.setTimeout
